module.exports = __webpack_public_path__ + "img/play.4d880765.png";